<div
  class="h-100 w-100 position-relative cursor-pointer pointer-events-none bg-transparent webkit-tap-highlight-color-transparent"
  (click)="logout()"
>
  <finx-button
    [labeltext]="logoutWidgetData?.title ?? ''"
    class="pointer-events-none d-flex"
    [class]="isAllowedGlobalStyling ? globalStylingClass : 'w-100 h-100 is-center'"
    [rightIcon]="logoutWidgetData?.icon ?? ''"
    [rightIconSize]="iconStyle"
    [isAllowedGlobalStyling]="isAllowedGlobalStyling"
    [buttonStyle]="buttonStyles"
  ></finx-button>
</div>
